import mixpanel from 'mixpanel-browser';
import * as T from '../analytics.types';
import { AnalyticsAdapter } from '../analytics.adapter';
import { AnalyticsInitOptions } from '../analytics.types';
import { transportMethods } from '../analytics.constants';

export type AnalyticsInitOptionsMixPanel = AnalyticsInitOptions; // & Partial<Config>;

const handleErrorDistinctId = (nameFunction: string) => {
  const distinctID = mixpanel.get_distinct_id();
  if (!distinctID || distinctID === 'null' || distinctID === null) {
    /* eslint-disable no-console */
    console.error(`[MIXPANEL] Distinct ID is not set ${nameFunction}`);
  }
};

export class AnalyticsMixpanelAdapter implements AnalyticsAdapter {
  init(token: string, options: AnalyticsInitOptionsMixPanel): void {
    mixpanel.init(token, options);
    const currentId = mixpanel.get_distinct_id();
    if (!currentId || currentId === 'null' || currentId === null) {
      mixpanel.reset();
      mixpanel.init(token, options);
    }
    handleErrorDistinctId('init');
  }

  register(options: T.AnalyticsRegisterOptions): void {
    mixpanel.register(options);
    if (options.distinct_id) {
      mixpanel.identify(options.distinct_id);
      handleErrorDistinctId('register');
    }
  }

  identifyUser(user?: T.IdentifyUserData): void {
    if (!user || !user?.id) return;
    mixpanel.identify(String(user.id));
    mixpanel.people.set({
      $name: user.name,
      $email: user.email,
      $user_city: user.city,
      $user_state: user.state,
      $user_phone: user.phone,
      $user_birth_date: user.birthdate
    });
    handleErrorDistinctId('identifyUser');
  }

  sendEvent(
    eventName: T.AnalyticsEventName,
    props?: T.AnalyticsSendEventProps
  ): void {
    const { transport = transportMethods.xhr, ...eventProps } = props ?? {};
    mixpanel.track(eventName, eventProps, { transport });
  }

  cleanup(): void {
    mixpanel.reset();
  }
}
